import { render, staticRenderFns } from "./buyPacketModal.vue?vue&type=template&id=0250530c&scoped=true&"
import script from "./buyPacketModal.vue?vue&type=script&lang=js&"
export * from "./buyPacketModal.vue?vue&type=script&lang=js&"
import style0 from "./buyPacketModal.vue?vue&type=style&index=0&id=0250530c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0250530c",
  null
  
)

export default component.exports